import EdoSedi from './EdoSedi';

export default EdoSedi;
